import {styled} from "@mui/material/styles";
import * as React from "react";
import {ReactElement} from "react";
import {useDrawerContext} from "../contexts/DrawerContext";

const drawerWidth = 250;

const MainContent = styled('main', {shouldForwardProp: (prop) => prop !== 'open'})<{
    open?: boolean;
}>(({theme, open}) => ({
    flexGrow: 1, overflow: "auto", padding: theme.spacing(3), transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp, duration: theme.transitions.duration.leavingScreen,
    }), ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut, duration: theme.transitions.duration.enteringScreen,
        }), marginLeft: drawerWidth,
    }),
}));

interface Props {
    children: ReactElement | ReactElement[]
}

export function ContentPage({children}: Props) {

    const {open} = useDrawerContext();

    return <MainContent open={open}>
        {children}
    </MainContent>
}